import { Component } from '@angular/core';

@Component({
  selector: 'div[seo-text]',
  templateUrl: './seo-text.component.html',
  host: { class: 'seo-text' }
})
export class SeoTextComponent {
  constructor() {}
}
